import { FormData, FormErrors, IsFormValid, OnChangeFormInput } from '@/hooks';

export interface formSectorProductProps {
  formData: FormData;
  formErrors: FormErrors;
  onChangeFormInput: OnChangeFormInput;
  isFormValidSectorProduct: IsFormValid;
}

// eslint-disable-next-line no-shadow
export enum ShouldShowModal {
  cloneProduct = 'cloneProduct',
  producerLink = 'producerLink',
  copyProducerLink = 'copyProducerLink',
  producerLinks = 'producerLinks',
}

// eslint-disable-next-line no-shadow
export enum FormInputNameProducerLink {
  allowClone = 'allowClone',
  sectionName = 'sectionName',
  commission = 'commission',
}
